// Página do veículo (/pages/meu-veiculo). Veículo: URL (?marca=&modelo=&ano=[&tipo=][&fora=1])
// > ativo da garagem > nenhum (mostra o seletor grande). Com URL, grava na garagem e fica ativo.
// Blackout e Tela vêm filtrados (seção ds-vehicle-results); sem produto pro veículo, ou no modo fora
// do catálogo, aparece o cartão "sob encomenda" com o link do WhatsApp já com produto e veículo.
// Estados de cada bloco (data-estado): carregando (esqueleto de 2 cards) | ok | sob | erro.
window.ArpineDS.etapa?.("pagina-veiculo: importando core");
const core = await window.ArpineDS.importar("core");
window.ArpineDS.etapa?.("pagina-veiculo: core ok; importando garagem");
const { garagem, pintarSilhuetas } = await window.ArpineDS.importar("garagem");
window.ArpineDS.etapa?.("pagina-veiculo: garagem ok");
const cfg = window.ArpineDS;
const root = document.querySelector("[data-ds-vehicle-page]");

let veiculo = null;
let versao = 0;

async function lerDataset() {
  try {
    const r = await fetch(cfg.dataset);
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return await r.json();
  } catch (e) {
    return null; // sem dataset: segue com o veículo como veio na URL
  }
}

function mostrar(bloco, estado) {
  const grid = bloco.querySelector("[data-ds-grid]");
  bloco.dataset.estado = estado;
  grid.hidden = !(estado === "carregando" || estado === "ok");
  grid.setAttribute("aria-busy", String(estado === "carregando"));
  bloco.querySelector("[data-ds-sob]").hidden = estado !== "sob";
  bloco.querySelector("[data-ds-erro]").hidden = estado !== "erro";
}

function prepararWhatsApp(bloco, v) {
  const href = core.whatsappUrl(cfg.whatsapp, core.mensagemSobEncomenda(bloco.dataset.dsBloco, v));
  bloco.querySelector("[data-ds-sob-texto]").textContent = core.fillTemplate(bloco.dataset.sobTexto, { veiculo: core.labelVeiculo(v) });
  const botao = bloco.querySelector("[data-ds-sob-link]");
  botao.textContent = bloco.dataset.sobBotao;
  botao.href = href;
  bloco.querySelector("[data-ds-erro-wa]").href = href;
}

function esqueleto(bloco) {
  const cartao = () => {
    const li = document.createElement("li");
    li.className = "ds-skeleton";
    li.setAttribute("aria-hidden", "true");
    return li;
  };
  bloco.querySelector("[data-ds-grid]").replaceChildren(cartao(), cartao());
}

async function carregar(bloco, v, minhaVersao) {
  prepararWhatsApp(bloco, v);
  if (v.noCatalogo === false) {
    mostrar(bloco, "sob");
    return;
  }
  esqueleto(bloco);
  mostrar(bloco, "carregando");
  try {
    const r = await fetch(core.resultsUrl(bloco.dataset.handle, v, root.dataset.modo));
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    const doc = new DOMParser().parseFromString(await r.text(), "text/html");
    const res = doc.querySelector("[data-ds-results]");
    if (!res) throw new Error("resposta sem [data-ds-results]");
    if (minhaVersao !== versao) return; // trocou de veículo no meio do caminho
    if (Number(res.dataset.count) === 0) {
      mostrar(bloco, "sob");
      return;
    }
    bloco.querySelector("[data-ds-grid]").replaceChildren(...res.querySelector("[data-ds-results-grid]").children);
    mostrar(bloco, "ok");
    window.ArpineDS.etapa?.(`pagina-veiculo: ${bloco.dataset.dsBloco} ok (${res.dataset.count})`);
  } catch (e) {
    console.error(`[ds-vehicle-page] ${bloco.dataset.dsBloco}:`, e);
    window.ArpineDS.etapa?.(`pagina-veiculo: ${bloco.dataset.dsBloco} ERRO ${e?.message ?? e}`);
    if (minhaVersao === versao) mostrar(bloco, "erro");
  }
}

function renderizar(v) {
  veiculo = v;
  versao += 1;
  const blocos = [...root.querySelectorAll("[data-ds-bloco]")];
  root.dataset.estado = v ? "veiculo" : "vazio";
  window.ArpineDS.etapa?.(`pagina-veiculo: estado ${root.dataset.estado}`);
  root.querySelector("[data-ds-vazio]").hidden = Boolean(v);
  root.querySelector("[data-ds-head]").hidden = !v;
  blocos.forEach((b) => { b.hidden = !v; });
  if (!v) return;
  root.querySelectorAll("[data-ds-veiculo-nome]").forEach((el) => { el.textContent = core.labelVeiculo(v); });
  pintarSilhuetas(root.querySelector("[data-ds-head]"), v.tipo);
  blocos.forEach((b) => carregar(b, v, versao));
}

// URL da página com o veículo v (ou sem veículo): parte da query atual e troca SÓ os parâmetros do
// veículo, então view (testes em /pages/ds-preview?view=meu-veiculo), pb, preview_theme_id, utm_*,
// gclid e fbclid continuam.
const PARAMS_VEICULO = ["marca", "modelo", "ano", "tipo", "fora"];
function urlPagina(v) {
  const p = new URLSearchParams(location.search);
  PARAMS_VEICULO.forEach((k) => p.delete(k));
  if (v) for (const [k, val] of core.vehicleToParams(v)) p.set(k, val);
  const q = p.toString();
  return location.pathname + (q ? `?${q}` : "") + location.hash;
}

root.addEventListener("click", (e) => {
  const retry = e.target.closest("[data-ds-retry]");
  if (!retry || !veiculo) return;
  const bloco = retry.closest("[data-ds-bloco]");
  // O botão some junto com o aviso de erro: o foco vai pro título do bloco, não cai no <body>.
  const titulo = bloco.querySelector("h2");
  titulo.tabIndex = -1;
  titulo.focus();
  carregar(bloco, veiculo, versao);
});

// Início: URL > garagem > vazio. Renderiza ANTES de gravar, pra o evento da garagem não repetir a carga.
let inicial = core.vehicleFromParams(new URLSearchParams(location.search));
if (inicial) {
  // Grafia do dataset ("fiat" → "Fiat", "Citroen" → "Citroën") e tipo: os filtros comparam o valor EXATO
  // do metacampo, então link digitado à mão ou de anúncio com outra caixa/acento ainda acha os produtos.
  if (inicial.noCatalogo !== false) inicial = core.canonicalVehicle(await lerDataset(), inicial);
  if (!inicial.tipo) inicial = { ...inicial, tipo: core.TIPO_PADRAO };
  renderizar(inicial);
  garagem.adicionar(inicial);
} else {
  renderizar(garagem.ativo());
}

// Trocou o veículo ativo (header, gaveta, outra aba): atualiza a página e a URL sem recarregar.
document.addEventListener(core.EVENTO, (e) => {
  const v = e.detail?.ativo ?? null;
  if (!v) {
    // Garagem esvaziou (tirou o último veículo): volta pro seletor grande e tira o veículo da URL,
    // senão recarregar a página o gravaria de novo (a URL tem precedência).
    if (veiculo) {
      history.replaceState(null, "", urlPagina(null));
      renderizar(null);
    }
    return;
  }
  if (v.id === veiculo?.id) return;
  history.replaceState(null, "", urlPagina(v));
  renderizar(v);
});
